module.exports = __webpack_public_path__ + "img/SKII.4c991c12.png";